import LocalStorageService from 'src/services/LocalStorageService'
import {
  getAccountOfferStorageKey,
  removeLegacyOfferStorage
} from './offerStorage'

export const OFFER_HISTORY_STORAGE_KEY = 'exchangeOfferHistory'
export const OFFER_HISTORY_LIMIT = 20

export const OFFER_ENDPOINTS = {
  export: ['loadingLocation', 'returnLocation', 'loadingDate', 'returnDate'],
  import: [
    'pickupLocation',
    'unloadingLocation',
    'pickupDate',
    'unloadingDate'
  ],
  general: [
    'loadingLocation',
    'unloadingLocation',
    'loadingDate',
    'unloadingDate'
  ],
  container: [
    'availabilityLocation',
    'destinationLocation',
    'availabilityDate',
    null
  ],
  truck: [
    'availabilityLocation',
    'destinationLocation',
    'availabilityDate',
    null
  ]
}

const getLocationLabel = location => {
  if (!location) return ''
  return [location.name, location.postalCode].filter(Boolean).join(' ')
}

export const getOfferSnapshot = offer => {
  const endpointKeys = OFFER_ENDPOINTS[offer.offerType]
  if (!endpointKeys) return {}

  const [fromLocationKey, toLocationKey, fromDateKey, toDateKey] = endpointKeys
  return {
    from: getLocationLabel(offer[fromLocationKey]),
    to: getLocationLabel(offer[toLocationKey]),
    fromDate: fromDateKey ? offer[fromDateKey] || '' : '',
    toDate: toDateKey ? offer[toDateKey] || '' : '',
    container:
      (offer.container && offer.container.name) ||
      (offer.containerSemiTrailer && offer.containerSemiTrailer.name) ||
      '',
    shipowner: offer.shipowner && offer.shipowner.name,
    company:
      offer.issuer && offer.issuer.company && offer.issuer.company.name
        ? offer.issuer.company.name
        : ''
  }
}

export const getOfferHistory = userId => {
  const storageKey = getAccountOfferStorageKey(OFFER_HISTORY_STORAGE_KEY, userId)
  if (!storageKey) return []

  try {
    removeLegacyOfferStorage(OFFER_HISTORY_STORAGE_KEY)
    const history = JSON.parse(
      LocalStorageService.get(storageKey) || '[]'
    )
    return Array.isArray(history) ? history : []
  } catch (error) {
    return []
  }
}

export const addOfferToHistory = (offer, userId) => {
  const storageKey = getAccountOfferStorageKey(OFFER_HISTORY_STORAGE_KEY, userId)
  if (!storageKey) return []

  if (!offer || !offer.id || !offer.offerType || !offer.referenceNumber) {
    return getOfferHistory(userId)
  }

  const historyKey = `${offer.offerType}:${offer.id}`
  const nextHistory = [
    {
      id: offer.id,
      offerType: offer.offerType,
      referenceNumber: offer.referenceNumber,
      ...getOfferSnapshot(offer),
      viewedAt: Date.now()
    },
    ...getOfferHistory(userId).filter(
      historyOffer =>
        `${historyOffer.offerType}:${historyOffer.id}` !== historyKey
    )
  ].slice(0, OFFER_HISTORY_LIMIT)

  try {
    LocalStorageService.set(
      storageKey,
      JSON.stringify(nextHistory)
    )
  } catch (error) {
    return getOfferHistory(userId)
  }

  return nextHistory
}
